import { CloudDownloadOutlined } from '@ant-design/icons'
import { useDownload } from '@web/react-common'
import { Button, DatePicker, Table } from 'antd'
import moment from 'moment'
import React from 'react'

import { useGetStatisticsQuery } from '@/generated/graphql'

import s from './statistics.module.less'

export const StatisticsUserUsage: React.FC = () => {
  const [yearMonth, setYearMonth] = React.useState(moment())
  const { data } = useGetStatisticsQuery({
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'cache-and-network',
    variables: {
      input: {
        year: yearMonth.year(),
        month: yearMonth.month() + 1,
      },
      withUserInfo: true,
    },
  })

  const statistics = data?.statistics.userInfo || []

  const columns = [
    {
      title: '姓名',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: '邮箱',
      dataIndex: 'email',
      key: 'email',
    },
    {
      title: '登录次数',
      dataIndex: 'landingCount',
      key: 'landingCount',
    },
    {
      title: '登录天数',
      dataIndex: 'landingDayCount',
      key: 'landingDayCount',
    },
    {
      title: '发帖数',
      dataIndex: 'postingCount',
      key: 'postingCount',
    },
    {
      title: '互动数',
      dataIndex: 'interactionCount',
      key: 'interactionCount',
    },
    {
      title: '主页被访问数',
      dataIndex: 'beenVisitedCount',
      key: 'beenVisitedCount',
    },
    {
      title: '访问他人主页数',
      dataIndex: 'visitCount',
      key: 'visitCount',
    },
  ]

  const dataSource = statistics.map((data) => ({
    key: data.userId,
    name: data.name,
    email: data.email,
    landingCount: data.landingCount,
    landingDayCount: data.landingDayCount,
    postingCount: data.postingCount,
    beenVisitedCount: data.beenVisitedCount,
    visitCount: data.visitCount,
    interactionCount: data.interactionCount,
  }))

  const file = [
    [
      '姓名',
      '邮箱',
      '当月登录次数',
      '当月登录天数',
      '月发帖数',
      '月互动数',
      '个人主页被访问次数',
      '访问他人个人主页次数',
    ],
  ].concat(
    dataSource.map((value) => [
      value.name,
      value.email,
      value.landingCount?.toString() || '',
      value.landingDayCount?.toString() || '',
      value.postingCount?.toString() || '',
      value.interactionCount?.toString() || '',
      value.beenVisitedCount?.toString() || '',
      value.visitCount?.toString() || '',
    ])
  )
  const fileName = `Tale - 个人用量 - ${yearMonth.format('YYYY-MM')}.csv`

  return (
    <div className={s.userUsage}>
      <div className={s.actions}>
        {' '}
        <Button icon={<CloudDownloadOutlined />} type='link' onClick={() => useDownload(file, fileName)}>
          下载
        </Button>
        <DatePicker
          className={s.datePicker}
          picker='month'
          value={yearMonth}
          onChange={(value) => value && setYearMonth(value)}
        />
      </div>
      <Table dataSource={dataSource} columns={columns} />
    </div>
  )
}
